import { NgModule } from "@angular/core";
import { OverviewComponent } from "./overview.component";
import { RouterModule } from "@angular/router";
import {
  DxChartModule,
  DxPieChartModule,
  DxRangeSelectorModule,
  DxDataGridModule,
  DxPopupModule,
  DxSwitchModule,
} from "devextreme-angular";
import { CommonModule } from "@angular/common";
import { DevEpressCommonModule } from "src/app/dev-epress-common.module";
import { BookmarkModule } from "src/app/widgets/bookmark/bookmark.module";
import { FormsModule, ReactiveFormsModule } from "@angular/forms";
import { DxTableControllerDirective } from "src/app/directives/dx-table-controller.directive";
import { WebExportModule } from "src/app/widgets/web-export/web.export.module";
import { BookmarkNewComponent } from "src/app/widgets/bookmark-new/bookmark-new.component";
import { FiltersGroupModule } from "src/app/widgets/filters/filters-group/filters-group.module";
import { HelpButtonComponent } from "src/app/widgets/help-button/help-button.component";

@NgModule({
  declarations: [OverviewComponent],
  imports: [
    CommonModule,
	DxTableControllerDirective,
    DxDataGridModule,
    DxRangeSelectorModule,
    DxChartModule,
    DxPieChartModule,
    DevEpressCommonModule,DxSwitchModule,
    DxPopupModule,BookmarkModule,FormsModule,ReactiveFormsModule,WebExportModule,FiltersGroupModule,HelpButtonComponent,BookmarkNewComponent,
    RouterModule.forChild([
      {
        path: "",
        component: OverviewComponent,
      },
    ]),
  ],
})
export class NewOverviewModule {}
